<template>
    <el-dialog
        :visible="visible"
        :title="title"
        custom-class="fixed-size-modal"
        append-to-body
        @close="$emit('close')"
    >
        <product-form
            v-if="visible"
            ref="product-form"
            :current-supplier-id="currentSupplierId"
            :current-product="currentProduct"
            :is-editing-existing-product="isEditingExistingProduct"
            @save="handleSave"
        ></product-form>
        <div slot="footer" class="product-modal__footer">
            <el-button
                v-if="isEditingExistingProduct"
                type="danger"
                @click="handleDelete"
                >Delete</el-button
            >
            <el-button v-else type="danger" @click="$emit('close')"
                >Cancel</el-button
            >
            <el-button type="primary" @click="handleSave">Save</el-button>
        </div>
    </el-dialog>
</template>

<script>
import ProductForm from "../views/Products/components/ProductForm";

export default {
    components: {
        ProductForm,
    },
    props: {
        visible: Boolean,
        currentProduct: {
            type: Object,
            default: () => {
                return {};
            },
        },
        currentSupplierId: String,
    },
    data: () => ({}),
    computed: {
        isEditingExistingProduct() {
            return !!this.currentProduct._id;
        },
        title() {
            if (this.isEditingExistingProduct) {
                return "Edit Global Product";
            }
            return "Create New Global Product";
        },
    },
    methods: {
        async handleSave() {
            const productData = this.$refs["product-form"].productData;
            this.$emit("save", productData);
        },

        handleDelete() {
            if (this.isEditingExistingProduct) {
                this.$confirm(
                    `Are you sure you wish to delete the product ${
                        this.currentProduct.name
                    }?`,
                    "Confirm Delete",
                    {
                        confirmButtonText: "OK",
                        cancelButtonText: "Cancel",
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.$emit("delete", this.currentProduct._id);
                    })
                    .catch(() => {});
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables";
.product-modal-form {
    height: 100%;
}

.product-modal__footer {
    text-align: right;
}
.product-form__name-title {
    align-items: center;
    background-color: $grey;
    border-radius: 4px;
    display: flex;
    height: 40px;
    justify-content: center;
    margin-bottom: 30px;
    text-align: center;
}
</style>
